import enUs from './en-us';

export default enUs;
